import { Button } from '@journ/ui/button'
import { Icons } from '@journ/ui/icons'
import { useIntlayer } from 'react-intlayer'
import { useMemberParams } from './use-member-params'

const MembersFilterList = () => {
	const content = useIntlayer('hr-page')
	const { status, setParams } = useMemberParams()

	if (!status) return null

	const label = content.status[status as keyof typeof content.status]?.value ?? status

	return (
		<ul className='flex space-x-2'>
			<li>
				<Button
					className='h-9 px-2 bg-secondary hover:bg-secondary font-normal text-muted-foreground flex space-x-1 items-center group rounded-none'
					onClick={() => setParams({ status: null })}
				>
					<Icons.Clear className='scale-0 group-hover:scale-100 transition-all w-0 group-hover:w-4' />
					<span>{label}</span>
				</Button>
			</li>
		</ul>
	)
}

export { MembersFilterList }
